<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            shortcut="last30Days"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
        <app-input
          @input.native="onOrdersSearch"
          v-model="filter_search"
          class="input--300"
          type="search"
          placeholder="Search by product name"
          name="search"
        />
        <app-select
          @input="fetchItems"
          v-model="filter_employees"
          :options="suppliers_options"
          placeholder="Supplier"
          class="select--300"
        />
        <app-button theme="export" @click.native="onExport" :class="{'btn--export--loading': export_loading}">
          <img src="@/assets/img/export-icon.svg" alt="Export">
          <span>Export in .xlsx</span>
        </app-button>
      </app-cells>
      <app-cells><h2 class="title">
        Total value: {{ transfers_total ? transfers_total.toLocaleString() : 0 }} TSh | {{ transfers_total_usd ? transfers_total_usd.toLocaleString() : 0 }} USD
      </h2></app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__name>
          <div class="table-default__left">Product name</div>
        </template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'product-storage-products-detail', params: {id: row.id }}" class="table-default__link-border">
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #total_quantity="{ row }">
          {{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.total_quantity) }}
        </template>
        <template #total_value="{ row }">
          {{ row.total_value.toLocaleString() }} TSh
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { getProductStorageOrdersAnalytics, getProductStorageTransferAnalyticsExport, getSuppliersProduct } from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { format, parse } from 'date-fns'

export default {
  name: 'ProductStorageAnalyticsOrders',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      export_loading: false,
      transfers_total: null,
      transfers_total_usd: null,
      is_loaded: false,
      filter_search: '',
      filter_employees: '',
      filter_dates: null,
      custom_shortcuts: [
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      date_picker_error: false,
      suppliers_options: [],
      table: {
        items: [],
        columns: ['name', 'measurement.name', 'total_quantity', 'total_value'],
        options: {
          headings: {
            'name': 'Product name',
            'measurement.name': 'Unit',
            'total_quantity': 'Quantity',
            'total_value': 'Total value',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 10000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    this.is_loaded = true
    getSuppliersProduct().then(response => { this.suppliers_options = response.data })
    this.$nextTick(() => {
      this.fetchItems()
    })
  },
  methods: {
    fetchItems() {
      getProductStorageOrdersAnalytics({
        search: this.filter_search,
        supplier: this.filter_employees && this.filter_employees.id,
        date_range_after: this.filter_dates.start,
        date_range_before: this.filter_dates.end,
      })
        .then(response => {
          this.transfers_total = response.data.total_value
          this.transfers_total_usd = response.data.total_value_usd
          this.table.items = response.data.products
        })
    },
    onIsHiddenPicker() {
      if (this.filter_dates.hasOwnProperty('start') &&
        this.filter_dates.start &&
        this.filter_dates.hasOwnProperty('end') &&
        this.filter_dates.end) {
        this.date_picker_balance_error = false
        this.fetchItems()
      } else this.date_picker_balance_error = true
    },
    onOrdersSearch() {
      this.searchUsers(this)
    },
    searchUsers: debounce(vm => {
      vm.fetchItems()
    }, 350),
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    onExport() {
      this.export_loading = true
      getProductStorageTransferAnalyticsExport(
        {
          supplier: this.filter_employees && this.filter_employees.id,
          date_range_after: this.filter_dates.start,
          date_range_before: this.filter_dates.end,
        }
      )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Product storage orders analytics from ${this.dateFormat(this.filter_dates.start)} to ${this.dateFormat(this.filter_dates.end)}${this.filter_employees ? ` ${this.filter_employees.name}` : ''} ${format(new Date(), 'dd.MM.yyyy HH_mm')}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.export_loading = false
        })
    },
  }
}
</script>

<style lang="sass">
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
